export default {
  // Loading status
  loadingHistory: "Loading conversation content...",

  // Room and user information
  aiAssistant: "AI Assistant",
  aiAssistantXiaoTu: "AI Assistant - Xiao Tu",
  you: "You",
  today: "Today",
  online: "Online",

  // Welcome messages
  welcomeConsult: "Welcome to consult AI Assistant",
  welcomeMessageRobot:
    "Hello, I'm AI Assistant - Xiao Tu.<br/>How can I help you?",
  welcomeMessageFull: `Hello! I'm Xiao Tu, an intelligent assistant. I integrate advanced AI capabilities of large models with TuLian's deep practical experience in virtual currency crime tracking and risk control, dedicated to providing you with professional virtual currency security and compliance support and product usage guidance.
 You can ask me anything about:
• What are the canvas operation shortcuts?
• Which cryptocurrencies does the canvas support for analysis?
• How to create a case?
• How to identify virtual currency risks?
• Suspicious transaction pattern analysis?
• Blockchain tracking basics?
• ...(Other specific product operation questions or other virtual currency crime, risk control, compliance, on-chain analysis related questions)`,

  // Chat component texts
  textMessages: {
    roomsEmpty: "No conversations",
    roomEmpty: "No conversation selected",
    newMessages: "New messages",
    messageDeleted: "This message has been deleted",
    messagesEmpty: "No messages",
    conversationStarted: "Conversation started at: ",
    typeMessage: "Please enter your question...",
    search: "Search",
    isOnline: "Welcome to consult AI Assistant",
    lastSeen: "Last seen ",
    isTyping: "Typing...",
  },

  // Initial greeting message
  initialGreeting: "Hello, I'm AI Assistant.<br/>How can I help you?",
};
